'use client';

import Image from 'next/image';

export function PhoneVisuals() {
  return (
    <div className="relative w-full flex items-center justify-center">
      <div className="relative max-w-md w-full drop-shadow-2xl">
        <Image
          src="/mascot.svg"
          alt="Mot du jour app illustration"
          width={380}
          height={392}
          className="w-full h-auto"
          priority
        />
      </div>
    </div>
  );
}
